import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdminService } from './api/admin.service';
import { AuthService } from './api/auth.service';
import { DefaultService } from './api/default.service';
import { SolarHuaweiAlarmService } from './api/solarHuaweiAlarm.service';
import { SolarHuaweiBasicService } from './api/solarHuaweiBasic.service';
import { SolarHuaweiMonitoringService } from './api/solarHuaweiMonitoring.service';
import { SolarHuaweiReportService } from './api/solarHuaweiReport.service';
import { SolarInverterAlarmService } from './api/solarInverterAlarm.service';
import { SolarInverterBasicService } from './api/solarInverterBasic.service';
import { SolarInverterMonitoringService } from './api/solarInverterMonitoring.service';
import { SolarInverterReportService } from './api/solarInverterReport.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
